import { render, staticRenderFns } from "./addman.vue?vue&type=template&id=3086201f&"
import script from "./addman.vue?vue&type=script&lang=js&"
export * from "./addman.vue?vue&type=script&lang=js&"
import style0 from "./addman.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports